import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDxi-SYqGwDluTYMYTGS7XOSJQLo8P7F2M",
  authDomain: "dataskyhsm.firebaseapp.com",
  databaseURL: "https://dataskyhsm.firebaseio.com",
  projectId: "dataskyhsm",
  storageBucket: "dataskyhsm.appspot.com",
  messagingSenderId: "438491859898",
  appId: "1:438491859898:web:8aba9760598acd67"
};
// const firebaseConfig = {
//   apiKey: "AIzaSyDS6AKMOIqBulgDWfaLkK7v4U3RDyiEGsI",
//   authDomain: "data-sky-hsm.firebaseapp.com",
//   databaseURL: "https://data-sky-hsm.firebaseio.com",
//   projectId: "data-sky-hsm",
//   storageBucket: "data-sky-hsm.appspot.com",
//   messagingSenderId: "1071004966073",
//   appId: "1:1071004966073:web:23c5d291e53c78d3"
// };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore()

export default firebase;